import React from "react";
import AddDataBodyHashLink from "./AddDataBodyHashLink";
import style from "../../style/AddBodySidebar.module.scss";

function AddDataSidebar() {
  return (
    <div className={style.container}>
      <AddDataBodyHashLink />
    </div>
  );
}

export default AddDataSidebar;
